import React from "react";
import { Button, Modal, Typography } from "@picklebet/ui";
import { FaceIdIcon } from "@picklebet/ui";
import { TouchIdIcon } from "@picklebet/ui";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { useBiometrics, dismissBiometricPrompt } from "../hooks/useBiometrics";
import { useUserId } from "../hooks/useUserId";
import { telemetry } from "@/utilities/telemetry";

import * as styles from "./EnableBiometricPrompt.module.scss";

const EnableBiometricPrompt = () => {
  const userId = useUserId();
  const modal = useShellStore((state) => state.modal);
  const setModal = useShellStore((state) => state.setModal);
  const { biometryType } = useShellStore(
    (state) => state.deviceBiometricAvailability,
  );
  const { enroll } = useBiometrics();

  const isOpen = modal === "enableBiometrics";

  const isFaceId = biometryType === "FaceID";
  const copy = {
    header: isFaceId ? "Enable Face ID" : "Enable Biometric Access",
    bodyHeader: isFaceId
      ? "Log in securely with a glance."
      : "Fast log in with your fingerprint or face.",
    buttonLabel: isFaceId ? "Enable Face ID" : "Enable Biometrics",
  };

  return (
    <Modal.Root open={isOpen} dismissible={false}>
      <Modal.Body>
        <Modal.Title visuallyHidden>Biometrics</Modal.Title>
        <Modal.Content>
          {isFaceId ? (
            <FaceIdIcon className={styles.icon} />
          ) : (
            <TouchIdIcon className={styles.icon} />
          )}
          <div className={styles.content}>
            <Typography variant="h2">{copy.header}</Typography>
            <Typography variant="lead" noSpacing className={styles.subHeader}>
              {copy.bodyHeader}
            </Typography>
            <Typography variant="body" noSpacing className={styles.body}>
              You can enable this later in your User Details.
            </Typography>
          </div>
        </Modal.Content>
        <Modal.Footer>
          <div className={styles.action}>
            <Button
              onClick={() => {
                enroll("prompt");
                setModal(null);
              }}
              size="md"
              variant="primary"
            >
              {copy.buttonLabel}
            </Button>
            <Button
              onClick={() => {
                dismissBiometricPrompt(userId);
                telemetry.biometricsSkipped();
                setModal(null);
              }}
              size="md"
              variant="noStyle"
            >
              Skip For Now
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Body>
    </Modal.Root>
  );
};

export { EnableBiometricPrompt };
